import React from 'react';
import { oneOf, string, func, bool, oneOfType, number, any, node } from 'prop-types';
import { Field } from '../../../../aem-core-components';
import AlertIcon from '../../../../resources/images/alert-triangle-red.svg';
import './input.scss';

const Input = props => {
    const {
        label,
        name,
        type,
        handleInputChange,
        handleInputBlur,
        handleInputFocus,
        classes,
        value,
        errorMsg,
        placeholder,
        maxLength,
        pattern,
        dataTestId,
        lbltestid,
        inputAriaLabel,
        inputAriaRequired,
        handleKeyDown,
        errorId,
        disclaimerMsg,
        showErrorIcon,
        required,
        inputRef,
        after,
        before,
        autoComplete,
        ...restProps
    } = props;

    const renderInputField = () => {
        return (
            <input
                id={name}
                className={`cmp-Field__field__input ${classes} ${errorMsg ? 'error_input__border' : ''}`}
                type={type}
                name={name}
                value={value}
                ref={inputRef}
                placeholder={placeholder}
                maxLength={maxLength}
                pattern={pattern}
                onChange={handleInputChange}
                onBlur={handleInputBlur}
                onKeyDown={handleKeyDown}
                onFocus={handleInputFocus}
                data-testid={dataTestId}
                autoComplete={autoComplete ? autoComplete: "off"}
                aria-label={!errorMsg ? inputAriaLabel : ''}
                aria-required={inputAriaRequired}
                aria-invalid={errorMsg ? true : false}
                aria-describedby={errorMsg ? errorId : undefined}
                {...restProps}
            />
        );
    };

    return (
        <Field
            label={label}
            htmlFor={name}
            lbltestid={lbltestid}
            errorMsg={errorMsg}
            required={required}
            fieldCustomClass={restProps?.fieldcustomclass}>
            {before || after ? (
                <div className="cmp-Field__inputWithIconWrapper">
                    {before && <span className="before">{before}</span>}
                    {renderInputField()}
                    {after && <span className="after">{after}</span>}
                </div>
            ) : (
                renderInputField()
            )}
            {errorMsg && (
                <span
                    className={`error_input ${restProps?.errorIconClass}`}
                    id={errorId}
                    role="alert"
                    aria-atomic="true"
                    aria-live="assertive">
                    <span className="sr-only">{label}</span>
                    {showErrorIcon && <AlertIcon tabIndex="-1" aria-hidden="true" />}
                    {showErrorIcon ? (
                        <span className="error_input__span" role="alert">
                            {errorMsg}
                        </span>
                    ) : (
                        errorMsg
                    )}
                </span>
            )}
            {disclaimerMsg && <span className="disclaimer_msg">{disclaimerMsg}</span>}
        </Field>
    );
};

Input.propTypes = {
    type: oneOf(['text', 'password', 'submit', 'button', 'reset', 'number']),
    errorMsg: any,
    label: string,
    name: string,
    placeholder: string,
    value: oneOfType([string, number]),
    pattern: string,
    handleInputChange: func,
    handleInputFocus: func,
    handleInputBlur: func,
    handleKeyDown: func,
    classes: string,
    inputAriaLabel: string,
    readOnly: bool,
    inputAriaRequired: bool,
    disclaimerMsg: string,
    showErrorIcon: bool,
    required: bool,
    after: node,
    before: node,
    autoComplete: string
};

Input.defaultProps = {
    type: 'text',
    errorMsg: null,
    label: '',
    name: '',
    placeholder: '',
    value: '',
    pattern: null,
    classes: '',
    inputAriaLabel: '',
    handleInputChange: () => {},
    handleInputBlur: () => {},
    handleInputFocus: () => {},
    handleKeyDown: () => {},
    readOnly: false,
    inputAriaRequired: false,
    disclaimerMsg: '',
    showErrorIcon: false,
    required: false,
    after: null,
    before: null,
    autoComplete: "off"
};

export default Input;
